import { render, staticRenderFns } from "./AccidentList.vue?vue&type=template&id=7a2afd44&scoped=true&"
import script from "./AccidentList.vue?vue&type=script&lang=js&"
export * from "./AccidentList.vue?vue&type=script&lang=js&"
import style0 from "./AccidentList.vue?vue&type=style&index=0&id=7a2afd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2afd44",
  null
  
)

export default component.exports